import {
    array,
    boolean,
    integer,
    literal,
    number,
    object,
    string,
    union,
} from "superstruct";

import { ATTRIBUTE_TYPE } from "../constants";

// Text Filed
export const AttributeTextFieldContentSchema = object({
    type: literal(ATTRIBUTE_TYPE.TEXTFIELD),
    placeholder: string(),
});

// Single Value
export const AttributeSingleValueContentSchema = object({
    type: literal(ATTRIBUTE_TYPE.SINGLE_VALUE),
    asDropdown: boolean(),
    options: array(string()),
});

// Multi Value
export const AttributeMultiValueContentSchema = object({
    type: literal(ATTRIBUTE_TYPE.MULTI_VALUE),
    options: array(string()),
});

// Range
export const AttributeRangeContentSchema = object({
    type: literal(ATTRIBUTE_TYPE.RANGE),
    minLabel: string(),
    maxLabel: string(),
    options: array(integer()),
});

// Centered Range
export const AttributeCentredRangeContentSchema = object({
    type: literal(ATTRIBUTE_TYPE.CENTERED_RANGE),
    minLabel: string(),
    midLabel: string(),
    maxLabel: string(),
    options: array(number()),
});

// Date
export const AttributeDateContentSchema = object({
    type: literal(ATTRIBUTE_TYPE.DATE),
    component: string(),
});

// Location
export const AttributeLocationContentSchema = object({
    type: literal(ATTRIBUTE_TYPE.LOCATION),
    component: string(),
});

// Product Filters
export const ProductFiltersSchema = object({
    id: string(),
    title: string(),
    propertyName: string(),
    content: union([
        AttributeRangeContentSchema,
        AttributeCentredRangeContentSchema,
        AttributeSingleValueContentSchema,
        AttributeMultiValueContentSchema,
        AttributeTextFieldContentSchema,
    ]),
});

// Customer Filters
export const CustomerFiltersSchema = object({
    id: string(),
    title: string(),
    propertyName: string(),
    content: union([
        AttributeSingleValueContentSchema,
        AttributeMultiValueContentSchema,
        AttributeDateContentSchema,
        AttributeLocationContentSchema,
    ]),
});

export const AttributesFilterSchema = union([
    array(CustomerFiltersSchema),
    array(ProductFiltersSchema),
]);

export const AttributesFiltersSchema = object({
    customerFilters: array(CustomerFiltersSchema),
    productFilters: array(ProductFiltersSchema),
});
